import { ThumbnailSize } from '@ukpostbox/frontend-framework/lib/Components/Images/Thumbnails/ThumbnailTypes';
import React from 'react';
import { MailItemLockedThumbnail } from './Entries/MailItemLockedThumbnail';
import { MailItemNoThumbnail } from './Entries/MailItemNoThumbnail';
import { MapSingleMailItemThumbnailType } from './Types/ThumbnailTypes';
import { MailItemThumbnail } from './Entries/MailItemThumbnail';
import { MailItemTopUpRequiredThumbnail } from './Entries/MailItemTopUpRequiredThumbnail';

function MapSingleMailItemThumbnail(props: MapSingleMailItemThumbnailType) {
	if (props.file.isLocked) {
		return <MailItemLockedThumbnail size={props.size} />;
	}

	if (props.file.topupRequired) {
		return <MailItemTopUpRequiredThumbnail size={props.size} />;
	}

	if (!props.file.userFileThumbnails) {
		return <MailItemNoThumbnail mailType={props.mailType} size={props.size} />;
	}

	if (
		!!props.file.userFileThumbnails &&
		props.file.userFileThumbnails.length > 0 &&
		props.file.userFileThumbnails[0]?.linkToFile
	) {
		return (
			<MailItemThumbnail
				{...props.file.userFileThumbnails[
					props.size === ThumbnailSize.Large || props.size === ThumbnailSize.Aspect
						? props.file.userFileThumbnails.length - 1
						: 0
				]}
				size={props.size}
				onClickCallback={props.onClickCallback}
			/>
		);
	}

	if (!props.hideMissing) {
		return <MailItemNoThumbnail mailType={props.mailType} size={props.size} />;
	}

	return null;
}

export { MapSingleMailItemThumbnail };
